import React from "react";
import { InventoryTransferDetailDTO } from "../../../../../../types/inventory/transfer/InventoryTransferDetailTypes";
import ModalInfoCard from "../../../../../../components/Cards/ModalInfoCard";
import SectionDivider from "../../../../../Dividers/SectionDivider";
import InfoRow from "../../../../../Rows/InfoRow";

interface Props {
  detail: InventoryTransferDetailDTO;
}

const AuditSection: React.FC<Props> = ({ detail }) => {
  return (
    <>
      {/* ✅ Título + divisor */}
      <SectionDivider title="Auditoría" />

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        {/* ✅ Auditoría principal */}
        <ModalInfoCard title="Registro del Sistema">
          <InfoRow
            label="Creado en"
            value={`${detail.createdDate} ${detail.createdTime}`}
          />

          <InfoRow
            label="Actualizado en"
            value={`${detail.updatedDate} ${detail.updatedTime}`}
          />

          <InfoRow
            label="Revertido"
            value={detail.reversed ? "Sí" : "No"}
          />
        </ModalInfoCard>
      </div>
    </>
  );
};

export default AuditSection;
